<script>
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'

export default {
  name: 'settings.product-categories',
  mixins: [tableMixin],
  data () {
    return {
      isLoading: false,
      search: null,
      showForm: false,
      selectedId: null,
      fields: [
        {
          key: 'name',
          label: 'Name',
          thStyle: { width: '200px' },
          class: ' align-middle'
        },
        {
          key: 'description',
          label: 'Description',
          class: ' align-middle'
        },
        {
          key: 'parent_category_id',
          label: 'Parent Category',
          thStyle: { width: '200px' },
          class: ' align-middle'
        },
        {
          key: 'is_archived',
          label: 'Active',
          thStyle: { width: '100px' },
          class: 'text-center align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    customer_id: 'onRefresh',
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.currentPage = 1
        }
        this.onRefresh()
      }
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      this.selectedId = null
      let { items, total_rows } = await api.productCategories.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        orderBy: { name: 'asc', created_at: 'asc' },
        filters: []
      })
      this.data = [...items]
      this.totalRows = total_rows
      this.isLoading = false
    },
    onEdit (item) {
      this.selectedId = item.id
      this.copyId = null
      this.showForm = true
    },

    onNewCategory () {
      this.selectedId = null
      this.showForm = true
    },
    async onRemove (category) {
      if (category === undefined) return
      try {
        this.isLoading = true
        await api.productCategories.delete({
          id: category.id
        })
        this.$bvToast.toast(`Category '${category.name}' was removed!`, {
          title: 'Category Removed',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
        this.onRefresh()
      } catch (err) {
        this.$bvToast.toast(`${err}!`, {
          title: 'Error',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
      }
    }
  },
  computed: {}
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Product Categories</h4>
      <div class="my-4 d-flex justify-content-between align-items-center">
        <g-search-input
          v-model="search"
          placeholder="Find Categories"
          width="300px"
          class="mr-0 mr-2"
        /><b-btn class="btn-label" variant="primary" v-on:click="onNewCategory">
          <i class="bx bx-plus label-icon"></i>New Category
        </b-btn>
      </div>
      <b-table
        :show-empty="true"
        hover
        :items="data"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        thead-tr-class="border-bottom bg-light"
        tbody-tr-class="border-bottom "
        borderless
      >
        <template v-slot:cell(is_archived)="{ item }">
          <i
            class="far fa-check-circle text-success"
            v-if="!item.is_archived"
          ></i>
          <i class="fas fa-ban text-danger" v-else></i>
        </template>
        <template v-slot:cell(parent_category_id)="{ item }">
          <template v-if="item.parent_category_id">{{
            item.parent_category.name
          }}</template>
          <template v-else>-NA-</template>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="link"
              size="sm"
              @click="onEdit(row.item)"
              class="align-self-center mr-1 p-2"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="link"
              size="sm"
              @click="onRemove(row.item)"
              class="align-self-center p-2"
            >
              <i class="fas fa-trash-alt text-danger"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex align-items-center justify-content-between p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-inline-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select
            >Entries
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
      <app-product-category-form-dialog
        :visible.sync="showForm"
        :categoryId="selectedId"
        ref="category-form"
        v-on:created="onRefresh"
      />
    </b-card>
  </g-overlay>
</template>
